import { EntityCard } from "src/pages/ad-studio/insights/performance/view/entity-card";
import type { AdCardState } from "src/pages/ad-studio/insights/performance/view/types";
import { useAdCardItem } from "src/pages/ad-studio/insights/performance/view/use-ad-card-item";

type AdCardItemProps = AdCardState;

export const AdCardItem = ({
  name,
  media,
  pills,
  metrics,
}: AdCardItemProps) => {
  const { state, performAction } = useAdCardItem({ media });
  return (
    <EntityCard
      name={name}
      media={state.media}
      pills={pills}
      metrics={metrics}
      performAction={performAction}
    />
  );
};
